// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoMenuListOutlinedSvg from "@fishx/icons-svg/es/asn/PtoMenuListOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoMenuListOutlined = function PtoMenuListOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoMenuListOutlinedSvg
  }));
};

PtoMenuListOutlined.displayName = 'PtoMenuListOutlined';
export default React.forwardRef(PtoMenuListOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoMenuListOutlined.js
// module id = 3920
// module chunks = 0